import FastMarquee from "react-fast-marquee";

export default function Marquee() {
  const items = [
    "UFO COIN",
    "WE OUT HERE",
    "$UFO",
    "NÃO É UM BALÃO",
    "TAKE ME TO YOUR LIQUIDITY",
    "SECTOR 51 APPROVED",
    "TRUST NO CEX",
  ];
  return (
    <section id="marquee" data-testid="marquee-section" className="relative border-y border-primary/20 py-6 bg-black overflow-hidden">
      <FastMarquee gradient={false} speed={70} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span
            key={`${t}-${i}`}
            className="mx-8 font-display font-black text-4xl md:text-6xl tracking-tighter stroke-text"
          >
            {t} <span className="text-primary neon-glow-primary mx-4">◉</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
